import { useQuery } from "@tanstack/react-query";
import { Fragment, useEffect, useState } from "react";
import { Col, Form } from "react-bootstrap";
import Laoding from "../../../../../components/Loading";
import PaginateCard from "../../../../../components/PaginateCard";
import { getRequestByAuth } from "../../../../../function/helper";
import NewBankAccount from "./NewBankAccount";
import SelectBankAccount from "./SelectBankAccount";

function BankAccountHandler({ selectBankAccountId, setSelectBankAccountId }) {
  const [page, setPage] = useState(1);
  const [key, setKey] = useState();

  const { data, isFetching, refetch } = useQuery({
    queryKey: ["bank-accounts"],
    queryFn: () =>
      getRequestByAuth(
        `/bank-account/v1/list?items=4&page=${page}${
          key ? "&page=1&search=" + key : ""
        }`
      ).then(res => {
        if (res && res.status === 200) {
          return res.data;
        }

        return { count: 0, items: [] };
      }),

    placeholderData: { count: 0, items: [] },
    retry: 0,
    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (!isFetching) {
      refetch();
    }
  }, [page]);

  useEffect(() => {
    if (key?.length > 2 || key?.length === 0) {
      const timeOut = setTimeout(refetch, 1000);
      return () => clearTimeout(timeOut);
    }
  }, [key]);

  return (
    <div>
      <NewBankAccount onSubmit={() => refetch()} />
      <h5 className="mt-3">لطفا حساب بانکی مورد نظر را انتخاب کنید:</h5>

      <Col xs={12} sm={6} lg={4}>
        <Form.Control
          placeholder="جستجو بر اساس نام"
          value={key}
          onChange={e => setKey(e.target.value)}
        />
      </Col>

      {isFetching && <Laoding />}
      {!isFetching && (
        <Fragment>
          <section>
            {data.items.map(item => (
              <SelectBankAccount
                item={item}
                key={item.id}
                isSelected={item.id === selectBankAccountId}
                onSelect={() => setSelectBankAccountId(item.id)}
                onDelete={refetch}
              />
            ))}
          </section>

          <div className="mt-3">
            <PaginateCard
              count={data.count}
              numberItems={4}
              numberPage={page}
              onIndexChoose={number => setPage(number)}
            />
          </div>
        </Fragment>
      )}
    </div>
  );
}

export default BankAccountHandler;
